import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertAnnouncements } from "./ExpertAnnouncementsHook";
// Set the default state values for each context
const ExpertAnnouncementsContext = /*#__PURE__*/createContext({});
export const ExpertAnnouncementsContextProvider = ({
  children
}) => {
  const announcementList = useExpertAnnouncements();
  const announcementListValue = useMemo(() => ({
    ...announcementList
  }), [announcementList.announcements, announcementList.selectedAnnouncement]);
  return /*#__PURE__*/React.createElement(ExpertAnnouncementsContext.Provider, {
    value: announcementListValue
  }, children);
};
export const useExpertAnnouncementsContext = () => {
  return useContext(ExpertAnnouncementsContext);
};
ExpertAnnouncementsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};